export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13446.79f4df42.jpg";